<template>
	<div class="column" style="height: 100%;">
		<!-- 已开的页面标签卡 -->
		<pageTags></pageTags>
		<div style="display: flex;flex:1;;overflow: hidden;">
			<!-- 二级菜单 -->
			<pageMenus></pageMenus>
			<!-- 页面实际内容 -->
			<div style="flex: 1;margin:0 0px;padding: 6px;width: 100%;height: 100%;">
				<pageBody></pageBody>
			</div>
		</div>
	</div>
</template>

<script>
	import pageBody from './pageBody.vue'
	import pageTags from './pageTags.vue'
	import pageMenus from './pageMenus.vue'
	export default {
		components: {  pageMenus, pageBody,pageTags },
		data() {
			return {

			}
		},
		computed: {

		},

	}
</script>

<style scoped lang="less">

</style>